import { toastFn, type SavedWithUndoOptions, toastSavedWithUndo } from "./toast";
import type { NotifyVariant } from "@/types/notify.types";

interface ShimOptions {
  description?: string;
  duration?: number;
  dismissible?: boolean;
  action?: { label: string; onClick: () => void };
}

function make(variant: NotifyVariant) {
  return (message: string, opts: ShimOptions = {}) => toastFn({ variant, title: message, ...opts });
}

export const toast = {
  success: make("success"),
  error: make("danger"),
  info: make("info"),
  warning: make("warning"),
  message: make("info"),
};

export { toastSavedWithUndo };
export type { SavedWithUndoOptions };
